require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-getting-started-with-wordpress-in-openshift.json") })
        }
      }, "path---blog-getting-started-with-wordpress-in-openshift");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-getting-started-with-wordpress-in-openshift!./.cache/json/blog-getting-started-with-wordpress-in-openshift.json
// module id = 258
// module chunks = 231608221292675